"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsProviderSideEffects = void 0;
exports.subscribeUpdatesByTopEventsSSESaga = subscribeUpdatesByTopEventsSSESaga;
exports.unsubscribeUpdatesByTopEventsSSESaga = unsubscribeUpdatesByTopEventsSSESaga;
exports.resubscribeTopEventsSSESaga = resubscribeTopEventsSSESaga;
exports.subscribeEventProbabilitiesSSESaga = subscribeEventProbabilitiesSSESaga;
exports.unsubscribeEventProbabilitiesSSESaga = unsubscribeEventProbabilitiesSSESaga;
exports.reloadEventProbabilitiesSSESaga = reloadEventProbabilitiesSSESaga;
exports.resubscribeEventProbabilitiesSSESaga = resubscribeEventProbabilitiesSSESaga;
exports.handleProbabilitiesUpdate = handleProbabilitiesUpdate;
const pick_1 = __importDefault(require("lodash/pick"));
const effects_1 = require("redux-saga/effects");
const CoreConfiguration_1 = __importDefault(require("../../../config/CoreConfiguration"));
const selectors_1 = require("../../CommonDataProvider/selectors");
const types_1 = require("../../ConfigProvider/types");
const selectors_2 = require("../../ConfigProvider/selectors");
const saga_1 = require("../../ConfigProvider/saga");
const selectors_3 = require("../../LanguagesProvider/selectors");
const types_2 = require("../../../utils/api/types");
const objects_1 = require("../../../utils/objects");
const sse_1 = require("../../../utils/sse");
const utils_1 = require("../utils");
const slice_1 = require("../../MainPageProvider/slice");
const errors_1 = require("../../../utils/errors");
const PlayersProvider_1 = require("../../PlayersProvider");
const events_1 = require("../../../utils/events");
const handleStreamUpdatesV2_1 = require("../../../utils/outcomes/computeEventProbabilitiesByMarket/v3/stream/handleStreamUpdatesV2");
const findProbabilitiesWithPlayerIdParameter_1 = require("../../../utils/outcomes/findProbabilitiesWithPlayerIdParameter");
const selectors_4 = require("../selectors");
const constants_1 = require("../constants");
const slice_2 = require("../slice");
const eventProcessingSaga_1 = require("./eventProcessingSaga");
const fetchEventsSaga_1 = require("./fetchEventsSaga");
exports.eventsProviderSideEffects = {
    [constants_1.SOURCE_KEY_EVENT_PROBABILITY_SSE]: {
        onSuccess: slice_2.eventsProviderActions.setCursorEventProbabilitiesSSE,
        onError: slice_2.eventsProviderActions.setStatusEventProbabilitiesSSE,
    },
};
const getParamsFetchEventSagaSSE = ({ eventId, }) => ({
    payload: {
        sideEffects: exports.eventsProviderSideEffects[constants_1.SOURCE_KEY_EVENT_PROBABILITY_SSE],
        reqData: {
            eventId,
            withCursor: true,
        },
        payload: {
            eventId,
            type: types_2.EEventMessageSSEType.ERROR,
        },
    },
    type: slice_2.eventsProviderActions.setCursorEventProbabilitiesSSE.type,
});
/* Подписка на обновления по всем топ событиям */
function subscribeUpdatesByTopEventsSSESaga(maxReconnectsAttempts = constants_1.MAX_RECONNECTS_ATTEMPTS_SSE_TOP_EVENTS, timeDelayReconnection = constants_1.TIME_DELAY_RECONNECTION_SSE_TOP_EVENTS) {
    return function* subscribeUpdatesByTopEventsSSESaga({ payload: { reloadInfo }, }) {
        try {
            const topEventChannelStatusType = yield (0, effects_1.select)(selectors_4.selectTopEventChannelStatusType);
            const topTagId = yield (0, effects_1.select)(selectors_1.selectTopTagId);
            const isEntityTagsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.ENTITY_TAGS_ENABLED);
            if (topEventChannelStatusType !== types_2.EEventMessageSSEType.CLOSED) {
                const reloadIdsToSkip = (reloadInfo === null || reloadInfo === void 0 ? void 0 : reloadInfo.id) ? [reloadInfo === null || reloadInfo === void 0 ? void 0 : reloadInfo.id] : [];
                const locale = yield (0, effects_1.select)(selectors_3.selectCurrentLangCode);
                const cursor = yield (0, effects_1.select)(selectors_4.selectTopEventCursorSSE);
                const sseConfiguration = (0, utils_1.createSSEConfiguration)(yield (0, effects_1.select)(selectors_2.selectApiBasePath), {
                    locale,
                    cursor,
                    topTagId,
                    reloadIdsToSkip,
                }, isEntityTagsEnabled);
                const eventSrc = CoreConfiguration_1.default.getInstance().sseBuilder.createInstance(sseConfiguration, {
                    withCredentials: true,
                });
                const channel = yield (0, effects_1.call)(sse_1.subscribeToSSE, eventSrc);
                yield (0, effects_1.put)(slice_2.eventsProviderActions.setTopEventsChannelSSE(channel));
                yield (0, effects_1.put)(slice_2.eventsProviderActions.setTopEventsSSEStatus({
                    type: types_2.EEventMessageSSEType.CONNECTED,
                }));
                while (true) {
                    const event = yield (0, effects_1.take)(channel);
                    const channelStatusType = yield (0, effects_1.select)(selectors_4.selectTopEventChannelStatusType);
                    const sseEventData = event.data && JSON.parse(String(event.data));
                    // set current sse channel status type
                    if (channelStatusType !== event.type) {
                        yield (0, effects_1.put)(slice_2.eventsProviderActions.setTopEventsSSEStatus({ type: event.type }));
                    }
                    // set a new cursor received via SSE
                    if (sseEventData === null || sseEventData === void 0 ? void 0 : sseEventData.cursor) {
                        yield (0, effects_1.put)(slice_2.eventsProviderActions.setCursorTopEvents({
                            cursor: sseEventData.cursor,
                        }));
                    }
                    // first handle case we make reload SSE connection
                    if ((sseEventData === null || sseEventData === void 0 ? void 0 : sseEventData.reload_info) && sseEventData.reload_info.id) {
                        yield (0, effects_1.spawn)(handleReloadTopEventsSSESaga, sseEventData.reload_info);
                        // second case handling SSE errors
                    }
                    else if (event.type === types_2.EEventMessageSSEType.ERROR) {
                        yield (0, effects_1.spawn)(handleErrorsTopEventsSSESaga, {
                            maxReconnectsAttempts,
                            timeDelayReconnection,
                        });
                        maxReconnectsAttempts -= 1;
                        timeDelayReconnection += 2000;
                        // third handle case we work with correct data
                    }
                    else if ((0, objects_1.checkIsNotEmptyOneObjectValue)((0, pick_1.default)(sseEventData, constants_1.SSE_TOP_EVENT_UPDATED_VALUES))) {
                        yield (0, effects_1.spawn)(setUpdatesTopEventsSSESaga, sseEventData);
                    }
                }
            }
        }
        catch (e) {
            const error = (0, errors_1.getErrorOrUnknown)(e);
            console.error('error subscribeUpdatesByTopEventsSSESaga', error);
        }
    };
}
function* unsubscribeUpdatesByTopEventsSSESaga() {
    try {
        const channel = yield (0, effects_1.select)(selectors_4.selectTopEventChannelSSE);
        channel === null || channel === void 0 ? void 0 : channel.close();
        yield (0, effects_1.put)(slice_2.eventsProviderActions.setTopEventsChannelSSE(null));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error unsubscribeUpdatesByTopEventsSSESaga', error);
    }
}
function* resubscribeTopEventsSSESaga({ payload: { reloadInfo }, }) {
    try {
        yield (0, effects_1.put)(slice_2.eventsProviderActions.unsubscribeTopEventsSSE(types_2.EEventMessageSSEType.PENDING));
        yield (0, effects_1.put)(slice_2.eventsProviderActions.subscribeTopEventsSSE({ reloadInfo }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error resubscribeTopEventsSSESaga', error);
    }
}
function* setUpdatesTopEventsSSESaga(sseEventData) {
    try {
        const { event, probabilities, statistics } = sseEventData;
        const eventId = (event === null || event === void 0 ? void 0 : event.id) || (probabilities === null || probabilities === void 0 ? void 0 : probabilities.eventId) || (statistics === null || statistics === void 0 ? void 0 : statistics.eventId);
        const existingEvent = yield (0, effects_1.select)((state) => (0, selectors_4.selectEventById)(state, eventId));
        // getting event when we do not have this event in our store
        if (eventId && !existingEvent) {
            yield (0, effects_1.call)(eventProcessingSaga_1.fetchEventInitiallySaga, eventId);
        }
        // if we have changes in Event, we should modify it in MainPageProvider (Main Page)
        if (event && event.tournament) {
            // It is bad that EventProvider knows something about MainPageProvider
            yield (0, effects_1.put)(slice_1.mainPageProviderActions.setTopEventSse({ event }));
            // That way we can dispatch event from EventsProvider and listen it on everywhere
            yield (0, effects_1.put)(slice_2.eventsProviderActions.eventChangedBySse({ event }));
        }
        // if there is not existing event, we save only the data that we will get by additional GET request
        // we make the request above in the code "yield call(fetchEventInitiallySaga, eventId)"
        if (existingEvent) {
            yield (0, effects_1.put)(slice_2.eventsProviderActions.setUpdatesTopEventsSSE(sseEventData));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error setUpdatesTopEventsSSESaga', error);
    }
}
function* handleReloadTopEventsSSESaga(reloadInfo) {
    try {
        yield (0, effects_1.spawn)(fetchEventsSaga_1.fetchEventsWithoutSideEffectsSaga, (0, constants_1.getParamsFetchTopLiveEvents)({ live: false }));
        yield (0, effects_1.call)(fetchEventsSaga_1.fetchEventsWithoutSideEffectsSaga, (0, constants_1.getParamsFetchTopLiveEvents)({ withCursor: true }));
        yield (0, effects_1.put)(slice_2.eventsProviderActions.resubscribeTopEventsSSE({
            reloadInfo,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error handleTopEventsSSEerrors', error);
    }
}
function* handleErrorsTopEventsSSESaga({ maxReconnectsAttempts, timeDelayReconnection, }) {
    try {
        yield (0, effects_1.put)(slice_2.eventsProviderActions.unsubscribeTopEventsSSE(types_2.EEventMessageSSEType.ERROR));
        if (maxReconnectsAttempts > 0) {
            yield (0, effects_1.delay)(timeDelayReconnection);
            yield (0, effects_1.call)(fetchEventsSaga_1.fetchEventsWithoutSideEffectsSaga, (0, constants_1.getParamsFetchTopLiveEvents)({ withCursor: true }));
            yield (0, effects_1.put)(slice_2.eventsProviderActions.subscribeTopEventsSSE({}));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error handleTopEventsSSEerrors', error);
    }
}
/* Подписка на обновления пробсов по одному событию в топ ( раскрытие росписи ) */
function subscribeEventProbabilitiesSSESaga(maxReconnectsAttempts = constants_1.MAX_RECONNECTS_ATTEMPTS_SSE_EVENT_PROBABILITIES, timeDelayReconnection = constants_1.TIME_DELAY_RECONNECTION_SSE_EVENT_PROBABILITIES) {
    return function* subscribeEventProbabilitiesSSESaga({ payload: { eventId, reloadInfo }, }) {
        const newOutcomesStructEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_STRUCT_ENABLED);
        try {
            yield (0, effects_1.put)(slice_2.eventsProviderActions.setStatusEventProbabilitiesSSE({
                eventId,
                type: types_2.EEventMessageSSEType.PENDING,
            }));
            // @ts-ignore
            yield (0, effects_1.call)(fetchEventsSaga_1.fetchEventSaga, getParamsFetchEventSagaSSE({ eventId }));
            const eventProbabilitiesStatusSSEById = yield (0, effects_1.select)((state) => (0, selectors_4.selectEventProbabilitiesStatusSSEById)(state, eventId));
            if (!constants_1.PROHIBITED_STATUSES_SSE_SUBSCRIPTION_LIST.includes(eventProbabilitiesStatusSSEById === null || eventProbabilitiesStatusSSEById === void 0 ? void 0 : eventProbabilitiesStatusSSEById.type)) {
                const reloadIdsToSkip = (reloadInfo === null || reloadInfo === void 0 ? void 0 : reloadInfo.id) ? [reloadInfo === null || reloadInfo === void 0 ? void 0 : reloadInfo.id] : [];
                const cursor = yield (0, effects_1.select)((state) => (0, selectors_4.selectEventProbabilitiesCursorSSEById)(state, eventId));
                const connectionUrl = yield (0, effects_1.select)((state) => (0, selectors_4.selectEventProbabilitiesSSEConfiguration)(state, {
                    eventId,
                    reloadIdsToSkip,
                    cursor,
                }));
                const eventSrc = CoreConfiguration_1.default.getInstance().sseBuilder.createInstance(connectionUrl, {
                    withCredentials: true,
                });
                const channel = yield (0, effects_1.call)(sse_1.subscribeToSSE, eventSrc);
                yield (0, effects_1.put)(slice_2.eventsProviderActions.setEventProbabilitiesChannelSSE({
                    eventId,
                    channel,
                }));
                yield (0, effects_1.put)(slice_2.eventsProviderActions.setStatusEventProbabilitiesSSE({
                    eventId,
                    type: types_2.EEventMessageSSEType.CONNECTED,
                }));
                while (true) {
                    const event = yield (0, effects_1.take)(channel);
                    const sseEventData = event.data && JSON.parse(String(event.data));
                    const eventProbabilitiesStatusSSEById = yield (0, effects_1.select)((state) => (0, selectors_4.selectEventProbabilitiesStatusSSEById)(state, eventId));
                    // set current sse channel status type
                    if ((eventProbabilitiesStatusSSEById === null || eventProbabilitiesStatusSSEById === void 0 ? void 0 : eventProbabilitiesStatusSSEById.type) !== event.type) {
                        yield (0, effects_1.put)(slice_2.eventsProviderActions.setStatusEventProbabilitiesSSE({
                            eventId,
                            type: event.type,
                        }));
                    }
                    // set a new cursor received via SSE
                    if (sseEventData === null || sseEventData === void 0 ? void 0 : sseEventData.cursor) {
                        yield (0, effects_1.put)(slice_2.eventsProviderActions.setCursorEventProbabilitiesSSE({
                            reqData: { eventId },
                            cursor,
                        }));
                    }
                    // first handle case we make reload SSE connection
                    if ((sseEventData === null || sseEventData === void 0 ? void 0 : sseEventData.reload_info) && sseEventData.reload_info.id) {
                        yield (0, effects_1.put)(slice_2.eventsProviderActions.reloadEventProbabilitiesSSE({
                            eventId,
                            reloadInfo: sseEventData.reload_info,
                        }));
                        // second case handling SSE errors
                    }
                    else if (event.type === types_2.EEventMessageSSEType.ERROR) {
                        yield (0, effects_1.spawn)(handleErrorsEventProbabilitiesSSESaga, {
                            maxReconnectsAttempts,
                            timeDelayReconnection,
                            eventId,
                        });
                        maxReconnectsAttempts -= 1;
                        timeDelayReconnection += 2000;
                        // third handle case we work with correct data
                    }
                    else if (sseEventData === null || sseEventData === void 0 ? void 0 : sseEventData.probabilities) {
                        if (newOutcomesStructEnabled) {
                            const event = yield (0, effects_1.select)((s) => (0, selectors_4.selectEventById)(s, eventId));
                            yield (0, effects_1.call)(handleProbabilitiesUpdate, event, sseEventData.probabilities);
                        }
                        else {
                            const sseProbabilitiesUpdateOptimizationEnabled = yield (0, effects_1.call)(saga_1.isSSEProbabilitiesUpdateOptimizationEnabled);
                            yield (0, effects_1.put)(slice_2.eventsProviderActions.setEventProbabilitiesUpdatesSSE({
                                eventId,
                                probabilities: sseEventData.probabilities,
                                sseProbabilitiesUpdateOptimizationEnabled,
                            }));
                            const event = yield (0, effects_1.select)((s) => (0, selectors_4.selectEventById)(s, eventId));
                            yield (0, effects_1.call)(eventProcessingSaga_1.computeEventProbabilitiesByMarketSaga, event);
                        }
                    }
                }
            }
        }
        catch (e) {
            const error = (0, errors_1.getErrorOrUnknown)(e);
            console.error('error subscribeEventProbabilitiesSSESaga', error);
        }
    };
}
function* unsubscribeEventProbabilitiesSSESaga({ payload: { eventId }, }) {
    try {
        const channel = yield (0, effects_1.select)((state) => (0, selectors_4.selectEventProbabilitiesChannelSSEById)(state, eventId));
        channel === null || channel === void 0 ? void 0 : channel.close();
        yield (0, effects_1.put)(slice_2.eventsProviderActions.setStatusEventProbabilitiesSSE({
            eventId,
            type: types_2.EEventMessageSSEType.CLOSED,
        }));
        yield (0, effects_1.put)(slice_2.eventsProviderActions.setEventProbabilitiesChannelSSE({
            eventId,
            channel: null,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('unsubscribeEventProbabilitiesSSESaga error', error);
    }
}
function* reloadEventProbabilitiesSSESaga({ payload: { eventId, reloadInfo }, }) {
    try {
        yield (0, effects_1.put)(slice_2.eventsProviderActions.setStatusEventProbabilitiesSSE({
            eventId,
            type: types_2.EEventMessageSSEType.PENDING,
        }));
        const channel = yield (0, effects_1.select)((state) => (0, selectors_4.selectEventProbabilitiesChannelSSEById)(state, eventId));
        channel === null || channel === void 0 ? void 0 : channel.close();
        // @ts-ignore
        yield (0, effects_1.call)(fetchEventsSaga_1.fetchEventSaga, getParamsFetchEventSagaSSE({ eventId }));
        yield (0, effects_1.put)(slice_2.eventsProviderActions.subscribeEventProbabilitiesSSE({
            eventId,
            reloadInfo,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error handleTopEventsSSEerrors', error);
    }
}
function* resubscribeEventProbabilitiesSSESaga() {
    try {
        const channels = yield (0, effects_1.select)(selectors_4.selectEventProbabilitiesChannelsSSE);
        Object.values(channels).forEach((channel) => {
            channel === null || channel === void 0 ? void 0 : channel.close();
        });
        const effects = Object.keys(channels).map((eventId) => (0, effects_1.put)(slice_2.eventsProviderActions.subscribeEventProbabilitiesSSE({
            eventId: +eventId,
        })));
        yield (0, effects_1.all)(effects);
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('resubscribeEventProbabilitiesSSESaga error', error);
    }
}
function* handleErrorsEventProbabilitiesSSESaga({ maxReconnectsAttempts, timeDelayReconnection, eventId, }) {
    try {
        yield (0, effects_1.put)(slice_2.eventsProviderActions.unsubscribeEventProbabilitiesSSE({ eventId }));
        if (maxReconnectsAttempts > 0) {
            yield (0, effects_1.delay)(timeDelayReconnection);
            yield (0, effects_1.put)(slice_2.eventsProviderActions.subscribeEventProbabilitiesSSE({
                eventId,
            }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error handleTopEventsSSEerrors', error);
    }
}
function* handleProbabilitiesUpdate(event, probabilities) {
    if (utils_1.EVENT_STATUSES_TO_CLEAR_OUTCOMES.includes(event.status)) {
        yield (0, effects_1.put)(slice_2.eventsProviderActions.clearOutcomes({ eventId: event.id }));
        return;
    }
    const vCategoriesInfo = yield (0, effects_1.select)(selectors_1.selectVirtualCategoriesInfo);
    const vCategoriesSortedIds = yield (0, effects_1.select)(selectors_1.selectVirtualCategoriesSortedIds);
    const probsWithPlayerIdParam = (0, findProbabilitiesWithPlayerIdParameter_1.findProbabilitiesWithPlayerIdParameter)(event.probabilities);
    const config = yield (0, effects_1.select)(selectors_2.selectConfig);
    const playersMap = yield (0, effects_1.select)(PlayersProvider_1.selectPlayers);
    const marketsMap = yield (0, effects_1.select)(selectors_1.selectMarkets);
    const vMarketIdsByMarket = yield (0, effects_1.select)(selectors_1.selectVMarketIdsByMarket);
    const vMarketsInfo = yield (0, effects_1.select)(selectors_1.selectVirtualMarketsInfo);
    const prevOutcomes = yield (0, effects_1.select)(selectors_4.selectOutcomes, event.id);
    const isNewSbCompetitorsNameEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_SB_COMPETITORS_NAME_ENABLED);
    const renameDate = yield (0, effects_1.select)(selectors_2.selectCompetitorsRenameDate);
    const eventCompetitors = (0, events_1.getHomeAwayCompetitorsRenamed)({
        event,
        renameDate,
        isNewSbCompetitorsNameEnabled,
    });
    const outcomesDiff = (0, handleStreamUpdatesV2_1.handleStreamUpdatesV2)({
        eventMarkets: probabilities.markets,
        eventStatus: event.status,
        vCategoriesInfo,
        vMarketsInfo,
        sportId: event.tournament.sportId,
        eventCompetitors,
        vCategoriesSortedIds,
        playersMap,
        probsWithPlayerIdParam,
        prevOutcomes,
        marketsMap,
        vMarketIdsByMarket,
        clientType: config.CLIENT_TYPE,
    });
    if (outcomesDiff) {
        yield (0, effects_1.put)(slice_2.eventsProviderActions.outcomesChanged({ eventId: event.id, outcomesDiff }));
    }
}
//# sourceMappingURL=sseSaga.js.map